import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_H_T, LL_V_L, ModuleFE_Dialog, } from '@nu-art/thunderstorm-frontend/index';
import { RuntimeModules } from '@nu-art/ts-common';
import './Dialog_DBExplorer.scss';
export class Dialog_DBExplorer extends ComponentSync {
    static show() {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_DBExplorer, {}), closeOverlayOnClick: () => true });
    }
    deriveStateFromProps(nextProps, state) {
        if (!state.groups || Object.keys(state.groups).length === 0)
            state.groups = this.buildGroups();
        state.expandedIds ??= new Set();
        state.entities ??= [];
        return state;
    }
    buildGroups() {
        const dbModules = RuntimeModules()
            .filter(m => m.dbDef?.dbKey);
        const groups = {};
        for (const module of dbModules) {
            const group = module.dbDef.frontend?.group ?? 'other';
            const dbKey = module.dbDef.dbKey;
            const entityCount = module.cache?.all()?.length ?? 0;
            (groups[group] ??= []).push({ module, dbKey, group, entityCount });
        }
        for (const key of Object.keys(groups))
            groups[key].sort((a, b) => a.dbKey.localeCompare(b.dbKey));
        return groups;
    }
    selectCollection = async (info) => {
        let entities;
        try {
            entities = info.module.cache?.all() ?? [];
            if (entities.length === 0 && info.module.IDB)
                entities = await info.module.IDB.query();
        }
        catch (e) {
            entities = [];
        }
        this.setState({ selectedDbKey: info.dbKey, entities, expandedIds: new Set() });
    };
    toggleEntity = (id) => {
        this.setState(prev => {
            const next = new Set(prev.expandedIds);
            if (next.has(id))
                next.delete(id);
            else
                next.add(id);
            return { expandedIds: next };
        });
    };
    close = () => ModuleFE_Dialog.close();
    render() {
        return _jsxs(LL_V_L, { id: 'dialog__db-explorer', children: [_jsxs(LL_H_C, { className: 'db-explorer__header', children: [_jsx("span", { className: 'db-explorer__title', children: "DB Explorer" }), _jsx("span", { className: 'db-explorer__shortcut', children: "Cmd+Shift+Alt+D" }), _jsx("span", { className: 'db-explorer__close', onClick: this.close, children: "\u2715" })] }), _jsxs(LL_H_T, { className: 'db-explorer__body', children: [this.renderSidebar(), this.renderContent()] })] });
    }
    renderSidebar() {
        const { groups, selectedDbKey } = this.state;
        const groupOrder = Object.keys(groups).sort();
        return _jsx(LL_V_L, { className: 'db-explorer__sidebar', children: groupOrder.map(groupName => _jsxs(LL_V_L, { className: 'db-explorer__group', children: [_jsx("div", { className: 'db-explorer__group-label', children: groupName }), groups[groupName].map(info => {
                        const isSelected = info.dbKey === selectedDbKey;
                        return _jsxs("div", { className: `db-explorer__collection${isSelected ? ' selected' : ''}`, onClick: () => this.selectCollection(info), children: [_jsx("span", { className: 'db-explorer__collection-name', children: info.dbKey }), _jsx("span", { className: 'db-explorer__collection-count', children: info.entityCount })] }, info.dbKey);
                    })] }, groupName)) });
    }
    renderContent() {
        const { selectedDbKey, entities, expandedIds } = this.state;
        if (!selectedDbKey)
            return _jsx(LL_V_L, { className: 'db-explorer__content db-explorer__empty', children: _jsx("span", { children: "Select a collection" }) });
        return _jsxs(LL_V_L, { className: 'db-explorer__content', children: [_jsxs("div", { className: 'db-explorer__content-header', children: [_jsx("span", { className: 'db-explorer__content-title', children: selectedDbKey }), _jsxs("span", { className: 'db-explorer__content-count', children: [entities.length, " entities"] })] }), _jsx(LL_V_L, { className: 'db-explorer__entity-list', children: entities.length === 0
                        ? _jsx("span", { className: 'db-explorer__no-data', children: "No entities in this collection" })
                        : entities.map((entity, i) => {
                            const id = entity._id ?? entity.id ?? `idx-${i}`;
                            const isExpanded = expandedIds.has(id);
                            return _jsxs(LL_V_L, { className: 'db-explorer__entity', children: [_jsxs(LL_H_C, { className: `db-explorer__entity-header${isExpanded ? ' expanded' : ''}`, onClick: () => this.toggleEntity(id), children: [_jsx("span", { className: 'db-explorer__entity-caret', children: isExpanded ? '▾' : '▸' }), _jsx("span", { className: 'db-explorer__entity-id', children: id })] }), isExpanded && _jsx("pre", { className: 'db-explorer__entity-json', children: JSON.stringify(entity, null, 2) })] }, id);
                        }) })] });
    }
}
//# sourceMappingURL=Dialog_DBExplorer.js.map